import { Box, InputAdornment, TextField } from '@mui/material';
import React, { useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { IconSearch } from '../../../../utils/icons';

export function SearchExpert() {
  const timeout = useRef<NodeJS.Timeout>();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchText, setSearchText] = useState(
    searchParams.get('search') || ''
  );

  const updateSearch = (e: any) => {
    const { value } = e.target;
    setSearchText(value);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      setSearchParams((prev) => {
        prev.set('search', value);
        return prev;
      });
    }, 300);
  };

  return (
    <Box>
      <TextField
        value={searchText}
        onChange={updateSearch}
        placeholder="Search"
        className="bg-surface-2 min-w-full sm:!min-w-[350px] rounded-lg"
        InputProps={{
          sx: {
            '& .MuiOutlinedInput-input': {
              paddingY: '10px',
              outline: 'none',
              border: 'none',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent',
            },
          },
          startAdornment: (
            <InputAdornment position="start">
              <IconSearch />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
